import React from 'react'
import { DragDropContext, Droppable, DropResult } from '@hello-pangea/dnd'
import { SortableQuestionItem } from './SortableQuestionItem'
import { Question } from '../../types/assessments'
import { reorderArray } from '../../utils/reorder'

interface SortableQuestionsListProps {
  questions: Question[]
  onReorder: (questions: Question[]) => void
  onEdit: (question: Question) => void
  onDelete: (questionId: number | string) => void
}

export const SortableQuestionsList: React.FC<SortableQuestionsListProps> = ({
  questions,
  onReorder,
  onEdit,
  onDelete
}) => {
  const handleDragEnd = (result: DropResult) => {
    if (!result.destination) {
      return
    }

    const { source, destination } = result

    if (source.index === destination.index) {
      return
    }

    const reorderedQuestions = reorderArray(questions, source.index, destination.index)

    // Update order numbers
    const updatedQuestions = reorderedQuestions.map((q, index) => ({
      ...q,
      order: index + 1
    }))

    onReorder(updatedQuestions)
  }

  return (
    <DragDropContext onDragEnd={handleDragEnd}>
      <Droppable droppableId='questions-list'>
        {(provided, snapshot) => (
          <div
            {...provided.droppableProps}
            ref={provided.innerRef}
            style={{
              backgroundColor: snapshot.isDraggingOver ? '#f5f5f5' : 'transparent',
              borderRadius: 8,
              padding: snapshot.isDraggingOver ? 8 : 0,
              transition: 'background-color 0.2s'
            }}
          >
            {questions.map((question, index) => (
              <SortableQuestionItem
                key={question.id || question.uuid || `question-${question.order}`}
                question={question}
                index={index}
                onEdit={() => onEdit(question)}
                onDelete={() => onDelete(question.id || question.uuid || '')}
              />
            ))}
            {provided.placeholder}
          </div>
        )}
      </Droppable>
    </DragDropContext>
  )
}
